import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "like-wrap"
}
const _hoisted_2 = { class: "like-content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "ico align-center" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "chen align-center" }, "x", -1)
const _hoisted_5 = { class: "num align-center" }
const _hoisted_6 = { class: "article-item-left" }
const _hoisted_7 = {
  href: "javascript:;",
  class: "right-item"
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "desc text" }
const _hoisted_11 = {
  key: 0,
  class: "time"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "timeSplit" }, "/", -1)
const _hoisted_13 = {
  key: 1,
  class: "author"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_article_count_down = _resolveComponent("article-count-down")!
  const _directive_onTouchActive = _resolveDirective("onTouchActive")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: "article-item-wrap",
    style: _ctx.itemBg
  }, [
    _createVNode("div", {
      class: "left-bg",
      style: _ctx.leftBg
    }, null, 4),
    (_ctx.isShowLikePart && _ctx.checkLikeNumReach)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.likeNum), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode("a", {
        href: "javascript:;",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.articleJumpLink({link:_ctx.leftLink,target: _ctx.target,redirectLink: _ctx.redirectLink}))),
        class: "img"
      })
    ]),
    _createVNode("div", {
      class: "article-item-right",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.articleJumpLink({link:_ctx.rightLink,target: _ctx.target,redirectLink: _ctx.redirectLink})))
    }, [
      _createVNode("a", _hoisted_7, [
        _createVNode("p", _hoisted_8, [
          _createVNode("p", _hoisted_9, _toDisplayString(_ctx.articleTitle), 1)
        ]),
        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.articleDesc), 1)
      ]),
      (_ctx.isShowTime)
        ? (_openBlock(), _createBlock("p", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.month), 1),
            _hoisted_12,
            _createTextVNode(_toDisplayString(_ctx.day), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowAuthor)
        ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.author), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_14,
    _createVNode("div", {
      class: ["tag", {hot:_ctx.tag === 'HOT',new:_ctx.tag === 'NEW'}]
    }, null, 2),
    (_ctx.isShowCountDown && _ctx.countdownSecond > 0)
      ? (_openBlock(), _createBlock(_component_article_count_down, {
          key: 1,
          countdownSecond: _ctx.countdownSecond
        }, null, 8, ["countdownSecond"]))
      : _createCommentVNode("", true)
  ], 4)), [
    [_directive_onTouchActive]
  ])
}